import Phaser from 'phaser';
import { addButton, addSprite } from '../utils/Builder';
import { Images as ABCyaImages, Tweens as ABCyaTweens, Text as ABCyaText, Audio as ABCyaAudio } from '@abcya/abcya_phaser';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';
import { horizontalScreenTransisition } from './IntroScreen';
import GameScreen from './GameScreen';
import SoundAssetKeys from '../SoundAssetKeys';

export default class SelectLevelScreen extends Phaser.Scene {
  static get KEY() { return 'SelectLevelScreen'; }

  create() {
    this.buttons = [];

    const width = this.scale.width;
    const height = this.scale.height;

    this.objectsAnimated = [];
    this.directions = [];

    const selectScreenCont = this.add.container();

    const back = ABCyaImages.addImage(0, 0, UIAssetKeys._Bckg, selectScreenCont).setOrigin(0);
    const topBar = addSprite(selectScreenCont, 'UIBarTop', 0, -334, true);
    const bottomBar = addSprite(selectScreenCont, 'UIBarBottom', 0, 368, true);
    const levelArea = addSprite(selectScreenCont, 'UILevelArea', 405, 0, false);

    let totalLevelsCleared = 0;

    for (let i = 0; i < gameData.LEVELS_CLEARED.length; i++) {
      const isTrue = gameData.LEVELS_CLEARED[i];

      if (isTrue) {
        totalLevelsCleared++;
      }

    }

    let slash = ' /';
    if (totalLevelsCleared > 9) {
      slash = '/';
    }

    const greenColor = 0X1FD56E;
    const levelsCompleted = ABCyaText.addText(width / 2 - 12, 8, '50pt', greenColor, FontKeys._linotte_bold, totalLevelsCleared + slash, this).setOrigin(0.5, 0);

    const totalLevels = ABCyaText.addText(width / 2 + 52, 28, '25pt', greenColor, FontKeys._linotte_bold, '45', this).setOrigin(0.5, 0);

    let xPos = 0;
    let yPos = 180;

    const spacing = 100;
    const spacingY = 120;

    for (let i = 0; i < 45; i++) {
      let button = null;
      if (gameData.LEVELS_CLEARED[i]) {
        button = addButton(selectScreenCont, 'LevelBtnCleared', 65 + (xPos * spacing), yPos, false, () => this.levelClicked(button));
      }
      else {
        button = addButton(selectScreenCont, 'LevelBtn', 65 + (xPos * spacing), yPos, false, () => this.levelClicked(button));
      }

      button.number = i + 1;
      button.setScale(0.9);

      const labelPoints = button.getBounds();
      const label = ABCyaText.addText(labelPoints.centerX, labelPoints.centerY, '40pt', 0xFFFFFF, FontKeys._linotte_heavy, button.number, this);
      button.textLabel = label;

      xPos++;

      if ((i + 1) % 10 === 0) {
        xPos = 0;
        yPos += spacingY;

      }

      moveOnScreen(button, 'down', 250, i * 20);
      moveOnScreen(label, 'down', 250, i * 20);

      this.buttons.push(button);
    }
  };

  levelClicked(button) {
    gameData.CURRENT_LEVEL = button.number;

    ABCyaAudio.playOneShot(SoundAssetKeys._click, this);

    this.buttons.forEach(btn => btn.disableInteractive());

    ABCyaTweens.addTween([button, button.textLabel], 200, { scaleX: 1.5, scaleY: 0.5, yoyo: true }, Phaser.Math.Easing.Bounce.Out,() => {
      horizontalScreenTransisition(this, GameScreen.KEY);
    });
  }
}

export function moveOnScreen(sprite, direction, delay, initialDelay, ease = Phaser.Math.Easing.Linear, easeParams = null) {

  const spriteWidth = sprite.getBounds().width;
  const spriteHeight = sprite.getBounds().height;
  const screenWidth = sprite.scene.scale.width;
  const screenHeight = sprite.scene.scale.height;

  let startY = 0;
  let startX = 0;
  const buffer = 20;

  switch (direction) {

    case 'right':
      startX = 0 - spriteWidth - buffer;
      break;

    case 'left':
      startX = screenWidth + spriteWidth + buffer;
      break;

    case 'up':
      startY = screenHeight + spriteHeight - buffer;
      break;

    case 'down':
      startY = 0 - spriteHeight - buffer;
      break;

    default:

      console.error('Error: direction has to be \'up\', \'down\', \'left\', or \'right');
      break;

  }

  if (direction === 'right' || direction === 'left') {

    const endX = sprite.x;
    // eslint-disable-next-line no-param-reassign
    sprite.x = startX;

    if (easeParams) ABCyaTweens.addTween(sprite, delay, { x: endX, delay: initialDelay, easeParams }, ease);
    else ABCyaTweens.addTween(sprite, delay, { x: endX, delay: initialDelay }, ease);

  }
  else {

    const endY = sprite.y;
    // eslint-disable-next-line no-param-reassign
    sprite.y = startY;
    if (easeParams) ABCyaTweens.addTween(sprite, delay, { y: endY, delay: initialDelay, easeParams }, ease);
    else ABCyaTweens.addTween(sprite, delay, { y: endY, delay: initialDelay }, ease);

  }
};